import { HistoryItem } from '../Timeline/types';
import { IconType } from '../Icon/Icon';
import { WaterServiceComment } from './WaterServiceDetail';
import { UserMode } from '@/hooks/useApolloClient';

export const convertWaterServiceComment = ({
  id,
  created,
  profile,
  comment,
}: WaterServiceComment): HistoryItem<'COMMENT'> => {
  const title: string | undefined = undefined;
  const icon: IconType = 'chat-dots';
  const iconColor: string | undefined = undefined;

  return {
    id,
    created: created ?? 0,
    profile,
    type: 'COMMENT',
    comment: comment || undefined,
    title,
    icon,
    iconColor,
    noRail: true,
  };
};

export const convertWaterHazardSurvey = (
  survey: any,
  mode: UserMode
): HistoryItem<'SURVEY'> => ({
  id: `survey-${survey.jobId}`,
  created: (survey.job.created as number | null) ?? 0,
  profile: null,
  type: 'SURVEY',
  title: 'Hazard survey created',
  icon: 'clipboard-check',
  iconColor: undefined,
  url: `/${mode}/hazard-surveys/${survey.jobId}`,
});

export const convertBackflowAssembly = (
  assembly: any,
  mode: UserMode
): HistoryItem<'ASSEMBLY'> => ({
  id: `assembly-${assembly.id}`,
  created: (assembly.created as number | null) ?? 0,
  profile: null,
  type: 'ASSEMBLY',
  title: assembly.serialNumber
    ? `Assembly #${assembly.serialNumber} added`
    : 'Assembly added',
  icon: 'wrench',
  iconColor: undefined,
  url: `/${mode}/assemblies/${assembly.id}`,
});

export const convertWaterServiceAttachment = (
  attachment: any
): HistoryItem<'ATTACHMENT'> => ({
  id: `attachment-${attachment.id}`,
  created: (attachment.created as number | null) ?? 0,
  profile: null,
  type: 'ATTACHMENT',
  title: 'Photo added',
  icon: 'image',
  iconColor: undefined,
  noRail: true,
});

export const convertServiceAddress = (
  serviceAddress: any,
  mode: UserMode
): HistoryItem<'CUSTOMER'> => {
  const customerName =
    serviceAddress.customer?.profile?.name ?? 'Unknown customer';
  return {
    id: `serviceaddr-${serviceAddress.id}`,
    created: (serviceAddress.created as number | null) ?? 0,
    profile: null,
    type: 'CUSTOMER',
    title: `Customer ${customerName} added`,
    icon: 'person',
    iconColor: undefined,
    url: `/${mode}/customers/${serviceAddress.customerId}`,
  };
};
